module.exports = __webpack_public_path__ + "static/media/caret.58b50503.svg";